/**
 * Public KVKK Aydınlatma Metni page.
 * Linked from the registration form and the in-app consent gate.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { KVKK_TEXT_DOCTOR } from '../lib/kvkk-text';

export default function KvkkPage() {
  return (
    <div className="min-h-screen bg-[#F8F7FC] py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center text-slate-600 hover:text-slate-900 mb-6 transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="px-6 py-5 border-b border-slate-100 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <h1
                className="text-xl font-bold text-slate-800"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                KVKK Aydınlatma Metni
              </h1>
              <p className="text-sm text-slate-500 mt-0.5">
                NeoBreed AI - Kişisel Verilerin Korunması Hakkında Bilgilendirme
              </p>
            </div>
          </div>

          <div className="px-6 py-6">
            <pre
              className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap font-sans"
              data-testid="public-kvkk-text"
            >
              {KVKK_TEXT_DOCTOR}
            </pre>
          </div>
        </div>

        <p className="text-center text-xs text-slate-400 mt-6">
          Sorularınız için: info@neobreedai.com
        </p>
      </div>
    </div>
  );
}
